//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RQ } from 'utils';
import { yoButton } from 'components';
import { Button } from 'vant';

// import { limit, eliese, dateshort, transformValidDate } from 'utils/filters';
import action from './action';

export default {
  name: 'result',
  props: ['params'],
  metaInfo: {
    title: '支付成功'
  },
  created: async function () {
  },
  data() {
    return {
      enterprise: this.params.enterprise,
      inviteCode: this.params.inviteCode || '',
      orderPrice: this.params.orderPrice,
      ordeNum: this.params.orderCode
    };
  },
  computed: {},
  components: {
    yoButton,
    'van-button': Button
  },
  methods: {
    ...action
  }
};




// WEBPACK FOOTER //
// ./src/module/cart/paySuccess/page.vue